import React from 'react';
import "./modal.css"
import ModalWrap from './index';
import { observer } from "mobx-react-lite"
import { useTranslation } from 'react-i18next';
import { property } from './../../store/poperty';


export interface DemandType{
    isOpen: boolean
    setIsOpen: () => void
    stud?: any
    
}

function DemandEduc({
    isOpen,
    setIsOpen}: DemandType) {

    
        const { t } = useTranslation();

    return ( 
        <>
            <ModalWrap isOpen={isOpen} setIsOpen={setIsOpen} id={12} title={t("st:modal:payEducTitle.main")}>
                <div className="main">
                    <div className="pay-educ">
                        <div className="pay-educ_titles">
                            <div className="pay-educ_title">{ t("st:modal:payEducTitle.year") }</div>
                            <div className="pay-educ_title">{t("st:modal:payEducTitle.rate")}</div>
                            <div className="pay-educ_title">{t("st:modal:payEducTitle.group")}</div>
                            <div className="pay-educ_title">{t("st:modal:payEducTitle.smeta")}</div>
                            <div className="pay-educ_title">{t("st:modal:payEducTitle.payment")}</div>
                            <div className="pay-educ_title">{t("st:modal:payEducTitle.duty")}</div>
                        </div>
                        {
                            property.payment.map(item => {
                                return(
                                    <div key={item.id_a_year } className="pay-educ_lists">
                                        <div className="pay-educ_item">
                                            {
                                                item.p32
                                            }
                                        </div>
                                        <div className="pay-educ_item">
                                            {
                                                item.p22
                                            }
                                        </div>
                                        <div className="pay-educ_item">
                                            {
                                                item.p20
                                            }
                                        </div>
                                        <div className="pay-educ_item">
                                            {
                                                item.p106
                                            }
                                        </div>
                                        <div className="pay-educ_item">
                                            {
                                                item.sum_opl
                                            }
                                        </div>
                                        <div className="pay-educ_item">
                                            {
                                                item.dolg
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                
            </ModalWrap>
        </>
     );
}

export default observer(DemandEduc);




